import styled from 'styled-components';

import { ContainerListPage as ListPage } from '../../../../../../components/List/styles';
import { RowItens as BaseRow } from '../../../../../../components/Modal/ModalInfoTemplete/styles';

export const RowItens = styled(BaseRow)`
  margin-bottom: 10px;
`;
// usado antes da recomendação técnica
export const RowItensLarge = styled(BaseRow)`
  margin-bottom: 30px;
`;

export const ContainerListPage = styled(ListPage)`
  width: 100%;
  max-height: none;
  overflow: visible;
  flex-shrink: 0;
`;

export const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const ActionButton = styled.button`
  margin-left: auto;
  margin-right: 15px;
  background-color: transparent;
  color: #ffffff; /* Teste do vermelho */
  border: 1px solid #ffffff;
  border-radius: 0.45rem;
  padding: 0.4rem 0.8rem;
  font-size: 0.75rem;
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.1s ease-in-out;
  &:hover {
    background-color: rgba(0, 0, 0, 0.15);
  }
`;
